<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>

    <b-row>
      <b-col>
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" md="6">
                    <span>Locations</span>
                  </b-col>
                  
                </b-row>
              </b-col>
              
            </b-row>
          </template>
          <b-row>
          <b-col cols="12" md="4">
                 
                  <b-form-group label="Country">
                    <b-form-select
                      v-model="countryselect"
                      :options="countrylist"
                      text-field="country"
                      value-field="_id"
                    ></b-form-select>
                   
                  </b-form-group>
                 
                </b-col>
                <b-col cols="12" md="4">
                  
                  <b-form-group  label="State">
                    <b-form-select
                      v-model="stateselect"
                      :options="statelist"
                      text-field="state"
                      value-field="_id"
                    ></b-form-select>
                    
                  </b-form-group>
                
                </b-col>
                 <b-col cols="12" md="4">
                  
                  <b-form-group  label="City">
                    <b-form-select
                      v-model="cityselect"
                      :options="citylist"
                      text-field="city"
                      value-field="_id"
                    ></b-form-select>
                    
                  </b-form-group>
                
                </b-col>
                </b-row>
        </b-card>
        <b-card height="100%">
          <template slot="header">
            <b-row>
              <b-col cols="12" md="6">
                <span>Add Location</span>
              </b-col>
            </b-row>
          </template>

          <b-row class="justify-content-md-center">
            <b-col cols="12" md="12">
              <b-row class="pt-3 justify-content-md-center">
                <b-col cols="12" md="3">
                  <b-form-group label="Country">
                    <b-form-input
                      name="lat"
                      type="text"
                      disabled
                      v-model="country"
                      class="form-control"
                      placeholder="Country"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                  <b-form-group label="Country Code">
                    <b-form-input
                      name="lon"
                      type="text"
                      disabled
                      v-model="code"
                      ref="myLngField"
                      placeholder="Country Code"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                  <b-form-group label="State">
                    <b-form-input
                      name="state"
                      type="text"
                      disabled
                      v-model="state"
                      ref="myLngField"
                      placeholder="State"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                  <b-form-group label="City">
                    <b-form-input
                      name="city"
                      type="text"
                      disabled
                      v-model="city"
                      ref="myLngField"
                      placeholder="City"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row align="center" class="pb-4">
                  <b-col>
                  <b-btn size="sm" variant="primary" @click="addLocation" style="width:200px">Add Location</b-btn>
                </b-col>
              </b-row>

              <div id="map" style="height:600px"></div>
            </b-col>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
        
      </b-col>
    </b-row>
  </div>
</template>
<script>
var marker;
var map = null;
var drawingManager;
var all_overlays = [];
export default {
  data() {
    return {
      forms: [],
      fields: [
       
        { key: "country", label: "Country", sortable: false },
         { key: "state", label: "State", sortable: false },
        { key: "city", label: "City", sortable: false },
       
      ],
      countrylist:[],
      statelist:[],
      citylist:[],
      countryselect:null,
      stateselect:null,
      cityselect:null,
      appLoading: false,
      ServerError: false,
      country: null,
      code: null,
      state: null,
      city: null,
      divisions: [],
      division: null,
      ranges: [],
      range: null,
      reportingDate: new Date().toISOString().substr(0, 10),
      map: null,
      location: [],
      polygonArray: [],
      sorted: [],
      oMarker: [],
      allElephants: [],
      elephants: [],
      elephantIndex: 0,
      lat: null,
      lon: null,
      repimages: new FormData(),
      urlarr: [],
      selectedFiles: null,
      repId: null,
      image: null,
      imgfiles: [],
    };
  },
  mounted() {
    this.getListClick();
    this.getcountry();
  },
  
  
  watch: {

    countryselect() {
      
      this.getState();
    },
     stateselect() {
      this.getCity();
    },
    
  },
  methods: {
    getListClick() {
      var vm = this;
      marker=false
      var options = {
        zoom: 3,
        center: new google.maps.LatLng(10.030551, 76.524354),
        mapTypeId: google.maps.MapTypeId.HYBRID,
        mapTypeControl: false,
      };
       map = new google.maps.Map(document.getElementById("map"), options);

      google.maps.event.addListener(map, "click", function (event) {
        var clickedLocation = {};
        clickedLocation.lat = event.latLng.lat();
        clickedLocation.lng = event.latLng.lng();
        if (marker == false) {
          marker = new google.maps.Marker({
            position: clickedLocation,
            map: map,
            draggable: true,
            clickable: true,
          });
         
          var latlng = clickedLocation.lat + "," + clickedLocation.lng;
          vm.getGeoLocation(latlng);
          // console.log(clickedLocation, "click");

           google.maps.event.addListener(marker, "dragend", function (event) {
            var dragLocation = {};
            
            dragLocation.lat = event.latLng.lat();
            dragLocation.lng = event.latLng.lng();
            // console.log(dragLocation, "click");
            var latlng = dragLocation.lat + "," + dragLocation.lng;
            vm.getGeoLocation(latlng);
          });
          
        } else {
          marker.setPosition(clickedLocation);
        }
        //Get the marker's location.
        // vm.markerLocation();
      });
    },
    markerLocation(clickedLocation) {
      var currentLocation = clickedLocation;
      // this.lat = currentLocation.lat(); //latitude
      // this.lon = currentLocation.lng(); //longitude
    },

    getGeoLocation(latlng) {
            this.city='',
            this.state='',
            this.code='',
            this.country='',
      axios({
        method: "GET",
        url: "https://maps.googleapis.com/maps/api/geocode/json",
        params: {
          latlng: latlng,
          key: this.googleAPIKey,
        },
      })
        .then((response) => {
        //  console.log(response.data.results);
          var data = response.data.results;
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].address_components.length; j++) {
              if (
                data[i].address_components[j].types[0] ==
                "locality"
              ) {
                this.city = data[i].address_components[j].long_name;
                // this.pincode = data[i].address_components[j].long_name;
              }
              if (
                data[i].address_components[j].types[0] ==
                "administrative_area_level_1"
              ) {
                this.state = data[i].address_components[j].long_name;
                // this.pincode = data[i].address_components[j].long_name;
              }
              if (data[i].address_components[j].types[0] == "country") {
                this.country = data[i].address_components[j].long_name;
                this.code = data[i].address_components[j].short_name;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

      getcountry() {
      this.appLoading = true;
     
      axios({
        method: "GET",
        url: "/country/getlistnew",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        
      })
        .then((response) => {
          this.appLoading = false;
           this.countrylist = response.data.data;
           this.getState();
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

     getState(item) {
      this.appLoading = true;
     
      axios({
        method: "GET",
        url: "/state/getlistnew",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params:{
          country:this.countryselect
        }
      })
        .then((response) => {
          this.appLoading = false;
           this.statelist = response.data.data;
           this.getCity();
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
     getCity(item) {
      this.appLoading = true;
     
      axios({
        method: "GET",
        url: "/city/getlistnew",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
         params:{
          state:this.stateselect
        }
        
      })
        .then((response) => {
          this.appLoading = false;
           this.citylist = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    
        addLocation() {
      this.appLoading = true;
      var data = {};
      data["country"] = this.country;
      data["countrycode"] = this.code;
      data["state"] = this.state;
      data["city"] = this.city;
     
      axios({
        method: "POST",
        url: "/location/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.appLoading = false;
           this.country = '';
           this.code = '';
           this.state = '';
           this.city = '';
          //  marker = false;
           this.getcountry();
          //  this.getState();
          //  this.getCity();
          
           
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
<style >
#map {
  height: 400px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.vdatetime-input {
  width: 100% !important;
}
</style>